import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type UpdateOnboardingStepMutationVariables = Types.Exact<{
  input: Types.UpdateStepInput
}>

export type UpdateOnboardingStepMutation = {
  __typename?: 'Mutation'
  updateOnboardingStep?: {
    __typename?: 'UpdateStepPayload'
    onboardingStep?: {
      __typename?: 'OnboardingStep'
      id: number
      stepType: Types.OnboardingStepType
      status: Types.OnboardingStatus
      startedAt?: string | null
      completedAt?: string | null
      assignee: {
        __typename?: 'User'
        id: number
        firstName?: string | null
        lastName?: string | null
        email?: string | null
      }
    } | null
    organization?: {
      __typename?: 'Organization'
      id: number
      onboardingWorkflow?: {
        __typename?: 'OnboardingWorkflow'
        id: number
        status: Types.OnboardingStatus
        steps: Array<{
          __typename?: 'OnboardingStep'
          id: number
          stepType: Types.OnboardingStepType
          status: Types.OnboardingStatus
          startedAt?: string | null
          completedAt?: string | null
          assignee: {
            __typename?: 'User'
            id: number
            firstName?: string | null
            lastName?: string | null
            email?: string | null
          }
        }>
      } | null
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const UpdateOnboardingStepDocument = `
    mutation UpdateOnboardingStep($input: UpdateStepInput!) {
  updateOnboardingStep(input: $input) {
    onboardingStep {
      id
      stepType
      status
      startedAt
      completedAt
      assignee {
        id
        firstName
        lastName
        email
      }
    }
    organization {
      id
      onboardingWorkflow {
        id
        status
        steps {
          id
          stepType
          status
          startedAt
          completedAt
          assignee {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useUpdateOnboardingStepMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateOnboardingStepMutation,
    TError,
    UpdateOnboardingStepMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateOnboardingStepMutation, TError, UpdateOnboardingStepMutationVariables, TContext>(
    ['UpdateOnboardingStep'],
    (variables?: UpdateOnboardingStepMutationVariables) =>
      fetchGql<UpdateOnboardingStepMutation, UpdateOnboardingStepMutationVariables>(
        UpdateOnboardingStepDocument,
        variables
      )(),
    options
  )
